import React, { Component } from 'react'
import { Row, Col, Card, Button, Container } from "react-bootstrap";
import "./_leadManagement.scss"
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import FollowupHistoryModal from './FollowupHistoryModal';
import LeadUpdateModal from './LeadUpdateModal';
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import moment from "moment";
import MyTaskLeadDetailsModal from './myTaskLeadDetailModal';


const GET_MY_TASKS = gql`
  query($employeeId: Int!) {
    getMyTasks(employeeId: $employeeId) {
      success
      statusCode
      message
      data {
        status_name
        status_count
        lead_details {
          wa_contact_id
          mobile
          name
          email
          lead_status_type_id
          lead_status_type_name
          calling_status_id
          calling_status_name
          comments
          followup_time
          branch_names
        }
      }
    }
  }
`;

const STATUS_COLORS = [
    '#6366f1', '#10b981', '#f97316', '#3b82f6',
    '#8b5cf6', '#f59e0b', '#ef4444', '#06b6d4',
];

const STATUS_ICONS = {
    'Total Leads':          'fal fa-users',
    'Today Follow Ups':     'fal fa-calendar-day',
    'Follow Ups Completed': 'fal fa-check-circle',
    'Follow Ups Pending':   'fal fa-clock',
};

const DEFAULT_ICON = 'fal fa-tag';


class MyRecords extends Component {
    constructor(props) {
        super(props)
        this.state = {
            myTasksData: this.props.getMyTasks,
            getCallStatusTypes: this.props.getCallStatusTypes,
            getLeadStatusTypes: this.props.getLeadStatusTypes,
            selectedIndex: 0,
            selectedCardData: [],
            selectCardStatusName: "",
            followupHistoryModal: false,
            leadUpdateModal: false,
            lead_id: "",
            rowData: null,
            myTaskLeadDetailsModal: false,
            myTaskrowData: [],
            loadingSpinner: 0,
            fieldsData: []
        }
    }

    componentDidMount() {
        // Render instantly from the prop the page already fetched...
        const buckets = this.state.myTasksData?.data;
        if (buckets && buckets.length > 0) {
            this.setState({
                selectedCardData: buckets[0].lead_details || [],
                selectCardStatusName: buckets[0].status_name,
            });
        }
        // ...then always re-call getMyTasks so opening the My Task tab shows
        // fresh data (the page-level query is cache-first and isn't re-run on
        // tab clicks).
        this.refreshTasks();
    }

    // Refetch My Tasks after a lead update so the table/KPIs refresh
    // in place — no full page reload.
    refreshTasks = async () => {
        const result = await this.props.client.query({
            query: GET_MY_TASKS,
            variables: { employeeId: parseInt(Cookies.get("id")) },
            fetchPolicy: "network-only",
        });
        const data = result.data.getMyTasks;
        this.setState((prev) => {
            const buckets = data?.data || [];
            const idx = prev.selectedIndex < buckets.length ? prev.selectedIndex : 0;
            return {
                myTasksData: data,
                selectedIndex: idx,
                selectedCardData: buckets[idx]?.lead_details || [],
                selectCardStatusName: buckets[idx]?.status_name || "",
            };
        });
    };

    articlecolumns = [
        {
            dataField: "lead_name",
            text: "Lead Name",
            sort: true,
            formatter: this.myTaskleadDetails.bind(this)
        },
        {
            dataField: "lead_mobile",
            text: "Lead Mobile",
            sort: true,
        },
        {
            dataField: "comment",
            text: "Comment",
            sort: true,
        },
        {
            dataField: "call_status",
            text: "Call Status",
            sort: true,
        },
        {
            dataField: "next_followp_date",
            text: "Next Followup Date",
            sort: true,
        },
        {
            dataField: "lead_id",
            text: "Lead Update & History",
            sort: false,
            formatter: this.leadUpdate.bind(this)
        },
    ];

    followupHistory(row, col) {
        return (
            <Button
                variant="link"
                name="view"
                className="text-theme"
                onClick={() => {
                    this.setState({ followupHistoryModal: true, lead_id: col.lead_id })
                }}
            >
                <i className="fas fa-eye text-primary mr-2" style={{ fontSize: "18px" }} />
            </Button>
        );
    }

    leadUpdate(cell, row) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <Button
                    variant="link"
                    title="Update Lead"
                    style={{ padding: '2px 6px' }}
                    onClick={() => this.setState({ leadUpdateModal: true, rowData: row, lead_id: row.lead_id })}
                >
                    <i className="fal fa-edit" />
                </Button>
                <Button
                    variant="link"
                    title="View History"
                    style={{ padding: '2px 6px' }}
                    onClick={() => this.setState({ followupHistoryModal: true, lead_id: row.lead_id })}
                >
                    <i className="fas fa-eye text-primary" style={{ fontSize: 16 }} />
                </Button>
            </div>
        );
    }

    getFormFieldsData = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int, $branch_id:String, $lead_id:Int! ) {
                getFormFieldsData(institute_id:$institute_id, branch_id:$branch_id, lead_id: $lead_id) {
                    form_fields_id
                    form_field_name
                    lead_id
                    lead_mobile
                    lead_name
                    value
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: Cookies.get("branch_id").toString(""),
                lead_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getFormFieldsData.length > 0) {
            this.setState({ fieldsData: result.data.getFormFieldsData, loadingSpinner1: 0 })
        } else {
            this.setState({ fieldsData: [], loadingSpinner1: 0 })
        }
    }

    myTaskleadDetails(val, row) {
        return (
            <a
                href="#"
                onClick={() => this.getFormData(row.lead_id, row.totalRowData)}
                style={{ color: "#000", textDecoration: "none" }}
                onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                onMouseLeave={(e) => e.target.style.textDecoration = "none"}
            >
                {row.lead_name}
            </a>
        );
    }

    getFormData = (value, data) => {
        this.getFormFieldsData(value)
        setTimeout(() => {
            this.setState({
                myTaskLeadDetailsModal: true,
                myTaskrowData: data
            })
        }, 600)
    }

    tableData(data) {
        return data.map((item) => ({
            lead_id: item.wa_contact_id,
            lead_status_type_id: item.lead_status_type_id,
            lead_name: item.name || "-",
            lead_mobile: item.mobile || "-",
            comment: item.comments || "-",
            call_status: item.calling_status_name || "-",
            next_followp_date: item.followup_time
                ? moment.unix(parseInt(item.followup_time)).format("DD MMM YYYY, hh:mm A")
                : "-",
            totalRowData: {
                ...item,
                lead_id: item.wa_contact_id,
                lead_name: item.name,
                lead_mobile: item.mobile,
            }
        }));
    }

    render() {
        const buckets = this.state.myTasksData?.data;

        if (!buckets || buckets.length === 0) {
            return (
                <section className="my-record">
                    <Container>
                        <Row className="my-3">
                            <Col className="text-center text-muted">No task records found.</Col>
                        </Row>
                    </Container>
                </section>
            );
        }

        const { selectedIndex, selectedCardData } = this.state;

        const FIN = {
            card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" },
            cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
            iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
            cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
            cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
            cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
            countBadge: { marginLeft: "auto", background: "#f5f3ff", color: "#7c3aed", borderRadius: 20, padding: "4px 14px", fontWeight: 600, fontSize: 12, border: "1px solid #ddd6fe" },
        };

        return (
            <section className="my-record">
                {/* KPI Stat Cards — click to filter the table */}
                <Row className="mb-4" style={{ gap: 0 }}>
                    {buckets.map((bucket, index) => {
                        const color = STATUS_COLORS[index % STATUS_COLORS.length];
                        const icon = STATUS_ICONS[bucket.status_name] || DEFAULT_ICON;
                        const isActive = selectedIndex === index;

                        return (
                            <Col xl={3} lg={3} md={4} sm={6} key={index} className="mb-3">
                                <div
                                    onClick={() => this.setState({
                                        selectedIndex: index,
                                        selectedCardData: bucket.lead_details || [],
                                        selectCardStatusName: bucket.status_name,
                                    })}
                                    style={{
                                        cursor: 'pointer',
                                        background: '#ffffff',
                                        borderRadius: 16,
                                        borderTop: `4px solid ${color}`,
                                        border: isActive ? `2px solid ${color}` : `1px solid #e2e8f0`,
                                        borderTopColor: color,
                                        padding: '20px 20px',
                                        boxShadow: isActive ? `0 6px 20px ${color}40` : '0 2px 8px rgba(0,0,0,0.04)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 16,
                                        transition: 'all 0.2s ease',
                                        transform: isActive ? 'translateY(-3px)' : 'none',
                                    }}
                                >
                                    <div style={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: 12,
                                        background: `${color}22`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                    }}>
                                        <i className={icon} style={{ fontSize: 20, color }} />
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 12, color: '#6b7280', fontWeight: 500, marginBottom: 2 }}>
                                            {bucket.status_name}
                                        </div>
                                        <div style={{ fontSize: 21, fontWeight: 700, color: '#1f2937', lineHeight: 1 }}>
                                            {bucket.status_count ?? 0}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>

                {/* Lead Table */}
                <div style={FIN.card}>
                    <div style={FIN.cardHeader}>
                        <div style={FIN.iconWrapper}><i className="fal fa-clipboard-list" /></div>
                        <div style={FIN.cardTitleText}>
                            <h6 style={FIN.cardTitle}>{this.state.selectCardStatusName || buckets[0]?.status_name}</h6>
                            <span style={FIN.cardSubtitle}>Your assigned leads and follow-ups</span>
                        </div>
                        <span style={FIN.countBadge}>{selectedCardData.length} leads</span>
                    </div>
                    <div style={{ padding: '20px 24px' }}>
                        {selectedCardData && selectedCardData.length > 0 ? (
                            <CardLessDataTableWithSearch
                                parentData={this.tableData(selectedCardData)}
                                particlecolumns={this.articlecolumns}
                                name="leads"
                            />
                        ) : (
                            <h6 className="no_data text-center text-muted mb-0">No Leads Available</h6>
                        )}
                    </div>
                </div>

                <FollowupHistoryModal
                    stateData={this.state}
                    show={this.state.followupHistoryModal}
                    onHide={() => this.setState({ followupHistoryModal: false, lead_id: "" })}
                />
                <LeadUpdateModal
                    stateData={this.state}
                    show={this.state.leadUpdateModal}
                    onHide={() => this.setState({ leadUpdateModal: false })}
                    onUpdated={this.refreshTasks}
                />
                <MyTaskLeadDetailsModal
                    stateData={this.state}
                    show={this.state.myTaskLeadDetailsModal}
                    onHide={() => this.setState({ myTaskLeadDetailsModal: false })}
                />
            </section>
        )
    }
}

export default withRouter(withApollo(compose(
)(MyRecords)));
